import React from 'react';
import './App.css';
import LoyaltyData from './loyaltydata.js';

function App() {
  return (
    <div className="App">
      <LoyaltyData/>
    </div>
  );
}

export default App;
